import type { RouteObject } from "react-router";
import { BetriebRahmen } from "./Rahmen";
import { Agenturen } from "./Agenturen";
import { AgenturDetail } from "./AgenturDetail";
import { Support } from "./Support";
import { Plattform } from "./Betriebsdaten";
import { Antraege } from "./Verwaltung";
import { Ueberwachung } from "./Ueberwachung";
import { Fehlermeldungen, FehlermeldungDetail, KiProtokoll, TicketBearbeiten, Tickets } from "./SupportTickets";
import { Rechtstexte } from "./Rechtstexte";
import { KiZugaenge } from "./KiZugaenge";
import { Rabattcodes } from "./Rabattcodes";
import { KuendigungswegBetrieb } from "./Kuendigungsweg";
import { Uebersicht } from "./Uebersicht";
import { Instagram } from "./Instagram";
import { DemoTermine } from "./DemoTermine";

/**
 * Betreiber-Konsole unter /betrieb (Zugangsprüfung: PlatformArea in app/layouts.tsx; jede Abfrage prüft die Datenbank erneut).
 * Die Seiten teilen sich den Rahmen der Vorlage (Kopfzeile, Bereichsnavigation, Hinweis).
 */
export const betriebRoutes: RouteObject[] = [
  {
    element: <BetriebRahmen />,
    children: [
      // 0213: Kacheln, Verlauf, Weg zum zahlenden Kunden, „Braucht Aufmerksamkeit“
      { index: true, element: <Uebersicht /> },
      { path: "agenturen", element: <Agenturen /> },
      { path: "agenturen/:orgId", element: <AgenturDetail /> },
      { path: "support", element: <Support /> },
      { path: "antraege", element: <Antraege /> },
      { path: "plattform", element: <Plattform /> },
      // 0101: Zeitpläne, Serverfunktionen, Mailversand
      { path: "ueberwachung", element: <Ueberwachung /> },
      // 0176: gemeldete Fehler und Tickets der Agenturen
      { path: "fehler", element: <Fehlermeldungen /> },
      { path: "fehler/:id", element: <FehlermeldungDetail /> },
      { path: "tickets", element: <Tickets /> },
      { path: "tickets/:id", element: <TicketBearbeiten /> },
      // 0177: Aktionen des Betreiber-Zugangs für Claude
      { path: "ki-protokoll", element: <KiProtokoll /> },
      // 0204: Schlüssel für Claude, ChatGPT und andere (Serverfunktion ki-api)
      { path: "ki-zugaenge", element: <KiZugaenge /> },
      // 0205: Rabattcodes (Stripe-Coupon und Promotion Code)
      { path: "rabattcodes", element: <Rabattcodes /> },
      // 0415: Halte-Quote des Kündigungswegs je Schritt, Grund und Angebot
      { path: "kuendigungsweg", element: <KuendigungswegBetrieb /> },
      // 0227: Nachrichten des eigenen Instagram-Kontos (nur lesen)
      { path: "instagram", element: <Instagram /> },
      // 0390: Demo-Termine freigeben, Buchungen der Website (creatoroffice.de/demo)
      { path: "demo-termine", element: <DemoTermine /> },
      // 0182: Fassungen der Rechtstexte, Ankündigung von Änderungen und neuen Unterauftragsverarbeitern
      { path: "rechtstexte", element: <Rechtstexte /> },
    ],
  },
];
